import { connect } from 'react-redux';
import { CompanyTreeSelector } from '../../Components/CompanySelector';

const mapStateToProps = (state, ownProps) => ({
  structureData: state.company.companyStructure,
  ...ownProps,
});

export const CompanyTreeSelectorWithData = connect(mapStateToProps)(CompanyTreeSelector);
